import { useEffect, useState, useCallback } from "react";

export const useQuery = (initialState = {}) => {
    const [formState, setFormState] = useState(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const paramsFromUrl = {};
        for (const [key, value] of searchParams.entries()) {
            paramsFromUrl[key] = value;
        }
        return { ...initialState, ...paramsFromUrl };
    });

    
    const getQueryString = useCallback(() => {
        const queryString = Object.entries(formState)
            .filter(([_, value]) => value !== undefined && value !== "" && value !== null)
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");
        return queryString ? queryString : "";
    }, [formState]);

    const updateUrlQuery = useCallback(() => {
        const currentQuery = new URLSearchParams(window.location.search).toString();
        const newQueryString = getQueryString();

        if (currentQuery === newQueryString) return;

        const newUrl = `${window.location.pathname}${newQueryString ? `?${newQueryString}` : ""}`;
        window.history.replaceState(null, "", newUrl);
    }, [getQueryString]);

    useEffect(() => {
        updateUrlQuery();
    }, [formState, updateUrlQuery]);

    const resetFilterUrl = useCallback(() => {
        setFormState({});
        window.history.replaceState(null, "", window.location.pathname);
    }, []);

    const filterUrl = useCallback(() => {
        return new URLSearchParams(window.location.search).toString();
    }, []);

    return {
        formState,
        setFormState,
        getQueryString,
        filterUrl,
        resetFilterUrl,
    };
};
